"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = reducer;

var _spec = require("./spec");

var _lodash = require("lodash");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var resource = _spec.RESOURCES.devices;
var initialState = {
  errors: {},
  data: {},
  pendingRequests: 0,
  isLoading: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var currentPendingRequests;

  switch (action.type) {
    case resource.actions.update.main:
      currentPendingRequests = state.pendingRequests + 1;
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: {},
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    case resource.actions.list.main:
      currentPendingRequests = state.pendingRequests + 1;
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: {},
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    case resource.actions.list.success:
      currentPendingRequests = state.pendingRequests - 1;
      return _objectSpread(_objectSpread({}, state), {}, {
        data: (0, _lodash.keyBy)(action.payload.results, 'id'),
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    case resource.actions.update.success:
      currentPendingRequests = state.pendingRequests - 1;
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, _defineProperty({}, action.payload.id, action.payload)),
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    case resource.actions.list.fail:
    case resource.actions.update.fail:
      currentPendingRequests = state.pendingRequests - 1;
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: action.payload,
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    default:
      return state;
  }
}